import type { PeakTrendPoint } from './coachPeakTrends';

export const WEEK_MS = 7 * 86400000;
export function weekStart(ms: number): number {
  const date = new Date(ms);
  date.setUTCHours(0, 0, 0, 0);
  date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 6) % 7);
  return date.getTime();
}
export function rankPeakWorkouts(points: PeakTrendPoint[], lowerIsBetter = false): PeakTrendPoint[] {
  const sorted = points.filter(p => Number.isFinite(p.y) && p.y > 0)
    .sort((a, b) => (lowerIsBetter ? a.y - b.y : b.y - a.y) || a.x - b.x || a.recordId - b.recordId);
  const seen = new Set<string>();
  return sorted.filter(p => {
    const key = `${p.athleteId}:${p.workoutId ?? `record-${p.recordId}`}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
export function weeklyPeakWinners(points: PeakTrendPoint[], lowerIsBetter = false): Map<number, PeakTrendPoint> {
  const result = new Map<number, PeakTrendPoint>();
  for (const point of rankPeakWorkouts(points, lowerIsBetter)) {
    const week = weekStart(point.x);
    if (!result.has(week)) result.set(week, point);
  }
  return result;
}
